<template>
    <form-row title="Review Dates" label_class="self-start mt-3" :no_border="true" class="mt-8">
        <div>
            <div class="flex flex-1 flex-col sm:flex-row">
                <input-date
                    class="w-56 mb-4 mr-6"
                    label="1st Review by City Council"
                    name="final_plat_review_first_council"
                    :value="commercial.final_plat_review_first_council"
                    :read_only="read_only"
                />

                <input-date
                    class="w-56 mb-4 mr-6"
                    label="2nd Review by City Council"
                    name="final_plat_review_second_council"
                    :value="commercial.final_plat_review_second_council"
                    :read_only="read_only"
                />
            </div>

            <div class="flex flex-1 flex-col sm:flex-row">
                <input-date
                    class="w-56 mb-4 mr-6"
                    label="1st Review by P & Z"
                    name="final_plat_review_first_p_z"
                    :value="commercial.final_plat_review_first_p_z"
                    :read_only="read_only"
                />

                <input-date
                    class="w-56 mb-4 mr-6"
                    label="2nd Review by P & Z"
                    name="final_plat_review_second_p_z"
                    :value="commercial.final_plat_review_second_p_z"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: {},
        read_only: { default: false },
    },
}
</script>
